// Featured Videos Component
window.addEventListener('DOMContentLoaded', () => {
  
  // Initialize mobile carousel if it exists
  const mobileCarousel = document.querySelector('.featured-videos__mobile .featured-videos__carousel');
  if (mobileCarousel) {
    new Swiper(mobileCarousel, {
      slidesPerView: 1.75,
      spaceBetween: 16,
      centeredSlides: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  // Handle video click events - same as customer stories
  const videos = document.querySelectorAll('.featured-videos__video-wrapper, .featured-videos__item');
  
  if (videos && typeof lity !== 'undefined') {
    videos.forEach((video) => {
      video.addEventListener('click', () => {
        const href = video.getAttribute('data-href');
        if (href) {
          lity(href);
        }
      });
    });
  }
});
